import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'cosmos-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubHeaderComponent {
  readonly title = input<string>(undefined);
}
